import { defineMessages } from 'react-intl';

export const objectWorkspaceMessages = defineMessages({
  additionalNotes: {
    defaultMessage: 'Additional notes',
    id: 'fa8HF+OSlt',
    description: 'Label for additional patient profile context',
  },
  allergies: {
    defaultMessage: 'Allergies',
    id: 'qypylg+tOq',
    description: 'Label for patient allergies',
  },
  currentMedications: {
    defaultMessage: 'Current medications',
    id: 'H9OE4fSW7Q',
    description: 'Label for a patient’s current medications',
  },
  dateOfBirth: {
    defaultMessage: 'Date of birth',
    id: 'S7rRb5EkZk',
    description: 'Label for a patient’s date of birth',
  },
  details: {
    defaultMessage: 'Details',
    id: 'zC3ZOR6NW0',
    description: 'Patient object workspace facet label',
  },
  email: {
    defaultMessage: 'Email',
    id: 'NjG8oZTR7h',
    description: 'Label for a patient’s email address',
  },
  emptyPatientDetail: {
    defaultMessage: '—',
    id: 'Bz/MjptJkG',
    description: 'Placeholder for a patient profile field with no value',
  },
  gender: {
    defaultMessage: 'Gender',
    id: 'm3gN2Ax22I',
    description: 'Label for a patient’s gender',
  },
  genderFemale: {
    defaultMessage: 'Female',
    id: '0oW0p1Ljv4',
    description: 'Display value for a female patient profile gender',
  },
  genderMale: {
    defaultMessage: 'Male',
    id: 'MD5voUSbLJ',
    description: 'Display value for a male patient profile gender',
  },
  genderOther: {
    defaultMessage: 'Other',
    id: 'hASD6I6CP4',
    description: 'Display value for another patient profile gender',
  },
  genderUnknown: {
    defaultMessage: 'Unknown',
    id: 'mglKhiuvdB',
    description: 'Display value for an unknown patient profile gender',
  },
  loadingPatientDetails: {
    defaultMessage: 'Loading patient details',
    id: 'N1UkITPVwa',
    description: 'Accessible status while patient profile details load',
  },
  patientDetailsUnavailable: {
    defaultMessage: 'Patient details are unavailable right now.',
    id: 'smHhnlXwnc',
    description: 'Quiet fallback when patient profile details cannot be loaded',
  },
  pastMedicalHistory: {
    defaultMessage: 'Past medical history',
    id: 'ijDTFVLXBm',
    description: 'Label for a patient’s past medical history',
  },
  phoneNumber: {
    defaultMessage: 'Phone number',
    id: 'zJMIhO54XF',
    description: 'Label for a patient’s phone number',
  },
  addPatient: {
    defaultMessage: 'Add patient',
    id: '27t569Yng3',
    description: 'Action to attach a patient to the selected encounter',
  },
  addWorkTab: {
    defaultMessage: 'Add tab',
    id: 'sq0o2SvUs8',
    description: 'Accessible label for adding an object-scoped work tab',
  },
  anchorMoreActions: {
    defaultMessage: 'More actions for {title}',
    id: 'SR++sliIX2',
    description: 'Accessible label for an object anchor card overflow action',
  },
  closeWorkspace: {
    defaultMessage: 'Close object workspace',
    id: '9q6rhHk5JO',
    description: 'Accessible label for closing the selected object workspace',
  },
  expandObjectPane: {
    defaultMessage: 'Expand {name} object pane',
    id: 'xZgF3i/VGl',
    description:
      'Accessible label for restoring the full patient or encounter pane from its collapsed rail',
  },
  documents: {
    defaultMessage: 'Documents',
    id: 'NDUIhr9B6L',
    description: 'Object workspace facet label',
  },
  loadingDocuments: {
    defaultMessage: 'Loading documents',
    id: 'rVb5AcYUl2',
    description: 'Accessible status while the Documents facet loads',
  },
  documentsUnavailable: {
    defaultMessage: 'Documents are unavailable right now.',
    id: 'Emg8q3DSbv',
    description: 'Quiet fallback when the Documents facet cannot be loaded',
  },
  documentsHeading: {
    defaultMessage: 'Related documents',
    id: 'Dwnx+Bymr4',
    description: 'Heading for the object documents facet',
  },
  dismissWorkTab: {
    defaultMessage: 'Close tab {title}',
    id: 'Ehezx3kCpa',
    description: 'Accessible label for dismissing an object-scoped work tab',
  },
  draftDocuments: {
    defaultMessage: 'Draft documents',
    id: 'diJsXMadu7',
    description: 'Composer suggestion for drafting documents from the selected object',
  },
  encounterEyebrow: {
    defaultMessage: 'Encounter',
    id: 'u2DLSVf6Fy',
    description: 'Small label above the selected encounter object title',
  },
  followUp: {
    defaultMessage: 'Follow up',
    id: '9q62SypsIC',
    description: 'Composer suggestion for follow-up work about the selected object',
  },
  newThread: {
    defaultMessage: 'New',
    id: '6p4L8Eai1D',
    description: 'Initial title for an empty object-scoped work tab',
  },
  nextSteps: {
    defaultMessage: 'Next steps',
    id: 'FeDoeAlubS',
    description: 'Composer suggestion for working on encounter next steps',
  },
  noDocuments: {
    defaultMessage: 'No documents yet.',
    id: '0mj/ksuMa0',
    description: 'Empty state for the object workspace Documents facet',
  },
  objectHarnessLabel: {
    defaultMessage: 'Heidi threads for {name}',
    id: 'oPbKFI0pvV',
    description: 'Accessible label for the object-scoped work harness',
  },
  openLastSession: {
    defaultMessage: 'Open last session',
    id: 'Sv90C5lF3Z',
    description: 'Harness action for opening the most recent session',
  },
  patientObjectPane: {
    defaultMessage: 'Patient details for {name}',
    id: 'M3btM8qXQP',
    description: 'Accessible label for the selected patient object pane',
  },
  openPatientWorkspace: {
    defaultMessage: 'Open patient workspace for {name}',
    id: 'h239qNgI8U',
    description:
      'Accessible label for opening the attached patient from an encounter pane',
  },
  patientIdentityNameAge: {
    defaultMessage: '{name}, {age, number}',
    id: 'HDMGAHtFSD',
    description: 'Attached patient name and age shown in an encounter pane',
  },
  patientIdentityNameSex: {
    defaultMessage: '{name}, {sexInitial}',
    id: '/yJedfbnjy',
    description: 'Attached patient name and sex initial shown in an encounter pane',
  },
  patientIdentityNameSexAge: {
    defaultMessage: '{name}, {sexInitial}, {age, number}',
    id: 'iMG4qvdb9Q',
    description: 'Attached patient name, sex initial, and age shown in an encounter pane',
  },
  pullUpSession: {
    defaultMessage: 'Pull up the session "{title}"',
    id: 'x4I/rcPGv+',
    description:
      'Composer prefill when a patient session is picked; title is the session name',
  },
  quickBrief: {
    defaultMessage: 'Quick brief',
    id: 'XeAs1FkTE+',
    description: 'Composer suggestion for a concise object summary',
  },
  sessions: {
    defaultMessage: 'Sessions',
    id: 'qK7oauakZp',
    description: 'Patient object workspace facet label',
  },
  sessionsHeading: {
    defaultMessage: 'Recent sessions',
    id: 'G7w4eABAx8',
    description: 'Heading for the patient sessions facet',
  },
  loadingPatientSessions: {
    defaultMessage: 'Loading sessions',
    id: 'yWiRUWH+Vr',
    description: 'Accessible status while the patient sessions facet loads',
  },
  patientSessionsUnavailable: {
    defaultMessage: 'Sessions are unavailable right now.',
    id: 'PBpBs9l7Jy',
    description: 'Quiet fallback when the patient sessions cannot be loaded',
  },
  noPatientSessions: {
    defaultMessage: 'No sessions for this patient yet.',
    id: 'jjdmpFZ/hC',
    description: 'Empty state for the patient sessions facet',
  },
  showMorePatientSessions: {
    defaultMessage: 'Show more sessions',
    id: 'ppSUyH5eHM',
    description: 'Loads the next page of sessions in the patient sessions facet',
  },
  startWork: {
    defaultMessage: 'Start work',
    id: 'ffQ0bqSAXU',
    description: 'Composer suggestion for starting work about the selected object',
  },
  switchObject: {
    defaultMessage: 'Switch from {name}',
    id: 'DlAKOh9f3F',
    description: 'Accessible label for opening the recent object switcher',
  },
  timeline: {
    defaultMessage: 'Timeline',
    id: 'kkK9eq4sZ+',
    description: 'Composer suggestion for reviewing a patient timeline',
  },
  visitObjectPane: {
    defaultMessage: 'Visit details for {name}',
    id: 'WbzCIZyv+/',
    description: 'Accessible label for the selected visit object pane',
  },
  workspaceLabel: {
    defaultMessage: 'Workspace for {name}',
    id: 'bEXwq1U/dk',
    description: 'Accessible label for the full selected object workspace',
  },
  workbenchLabel: {
    defaultMessage: 'Heidi workbench for {name}',
    id: 'eQuuzrk1ZJ',
    description: 'Accessible label for the workbench side of the object workspace',
  },
  whatsChanged: {
    defaultMessage: 'What’s changed',
    id: 'Y4z7k1a7iU',
    description: 'Composer suggestion for reviewing recent changes to an object',
  },
  work: {
    defaultMessage: 'Next Steps',
    id: 'ZdG5cqPIFz',
    description: 'Object workspace facet label',
  },
  workHeading: {
    defaultMessage: 'Open tasks',
    id: 'Alt1gNxnRT',
    description: 'Accessible label for the open tasks listed under Next Steps',
  },
  loadingTasks: {
    defaultMessage: 'Loading tasks',
    id: 'PgvaUe841L',
    description: 'Accessible status while the Next Steps tasks load',
  },
  tasksUnavailable: {
    defaultMessage: 'Tasks are unavailable right now.',
    id: 'bcOP/8xknM',
    description: 'Quiet fallback when the Next Steps tasks cannot be loaded',
  },
  noTasks: {
    defaultMessage: 'No open tasks.',
    id: 'Rw0AoLnGhu',
    description: 'Empty state for the Next Steps facet',
  },
  taskInProgress: {
    defaultMessage: 'In progress',
    id: 'xybK8V+BNK',
    description:
      'Status caption on a Next Steps task that Heidi or the clinician has started',
  },
  taskDue: {
    defaultMessage: 'Due {date}',
    id: 'F2jOkPWOPI',
    description: 'Due date caption on a Next Steps task; date is a short formatted date',
  },
  openLinkedTaskChat: {
    defaultMessage: 'Open chat with Heidi: {title}',
    id: 'ODYs3NTCu7',
    description:
      'Accessible label for a Next Steps task already linked to a Heidi chat; opens that chat',
  },
  workTabsLabel: {
    defaultMessage: 'Tabs',
    id: 'vKYTZzqnSW',
    description: 'Accessible label for object-scoped parallel work tabs',
  },
});
